/* tslint:disable */
/* eslint-disable */
/**
 * PR TIMES API 【企業詳細】
 * PR TIMESの企業詳細画面用のAPI
 *
 * The version of the OpenAPI document: 1.5.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    PressKitTag,
    PressKitTagFromJSON,
    PressKitTagFromJSONTyped,
    PressKitTagToJSON,
} from './PressKitTag';
import {
    PressKitThumbnailUrls,
    PressKitThumbnailUrlsFromJSON,
    PressKitThumbnailUrlsFromJSONTyped,
    PressKitThumbnailUrlsToJSON,
} from './PressKitThumbnailUrls';

/**
 * プレスキット資料の詳細
 * @export
 * @interface PressKitDocumentDetail
 */
export interface PressKitDocumentDetail {
    /**
     * PressKit Image UUID(v4)
     * @type {string}
     * @memberof PressKitDocumentDetail
     */
    id: string;
    /**
     * 企業が登録したファイルの名前（キャプション）
     * @type {string}
     * @memberof PressKitDocumentDetail
     */
    title: string;
    /**
     * 企業が登録したファイルの名前（title+extension）
     * @type {string}
     * @memberof PressKitDocumentDetail
     */
    filename: string;
    /**
     * 企業が登録したファイルの説明文。設定無しは''になる。
     * @type {string}
     * @memberof PressKitDocumentDetail
     */
    description: string;
    /**
     * ファイル拡張子（原則英語小文字）
     * @type {string}
     * @memberof PressKitDocumentDetail
     */
    extension: PressKitDocumentDetailExtensionEnum;
    /**
     * ファイルのサイズ（単位はbytes）
     * @type {number}
     * @memberof PressKitDocumentDetail
     */
    fileSize: number;
    /**
     * 
     * @type {PressKitThumbnailUrls}
     * @memberof PressKitDocumentDetail
     */
    thumbnailUrls: PressKitThumbnailUrls;
    /**
     * 画像のダウンロード用URL。別ドメイン。
     * @type {string}
     * @memberof PressKitDocumentDetail
     */
    downloadUrl: string;
    /**
     * 企業が設定しているタグの一覧
     * @type {Array<PressKitTag>}
     * @memberof PressKitDocumentDetail
     */
    readonly tags: Array<PressKitTag>;
}

/**
* @export
* @enum {string}
*/
export enum PressKitDocumentDetailExtensionEnum {
    Pdf = 'pdf'
}

export function PressKitDocumentDetailFromJSON(json: any): PressKitDocumentDetail {
    return PressKitDocumentDetailFromJSONTyped(json, false);
}

export function PressKitDocumentDetailFromJSONTyped(json: any, ignoreDiscriminator: boolean): PressKitDocumentDetail {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': json['id'],
        'title': json['title'],
        'filename': json['filename'],
        'description': json['description'],
        'extension': json['extension'],
        'fileSize': json['file_size'],
        'thumbnailUrls': PressKitThumbnailUrlsFromJSON(json['thumbnail_urls']),
        'downloadUrl': json['download_url'],
        'tags': ((json['tags'] as Array<any>).map(PressKitTagFromJSON)),
    };
}

export function PressKitDocumentDetailToJSON(value?: PressKitDocumentDetail | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'title': value.title,
        'filename': value.filename,
        'description': value.description,
        'extension': value.extension,
        'file_size': value.fileSize,
        'thumbnail_urls': PressKitThumbnailUrlsToJSON(value.thumbnailUrls),
        'download_url': value.downloadUrl,
    };
}

